import type { DraggableProps } from "react-draggable";

import type { IDragTypes } from "@components/atoms/dragContainer";

/**
 * Get DraggableProps based on the specified drag type.
 *
 * @param {IDragTypes} type - The type of drag behavior.
 * @returns {Partial<DraggableProps>} - DraggableProps with bounds set based on the drag type.
 */
export const getDraggablePropsFromType = (
  type: IDragTypes,
): Partial<DraggableProps> => {
  if (type === "on-body") {
    return { bounds: "body" };
  }
  // Set bounds to 'body' for 'on-body' type.
  if (type === "on-parent") {
    return { bounds: "parent" };
  }
  // Set bounds to 'parent' for 'on-parent' type.
  // Return an empty object for other types.
  return {};
};
